import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import fields from 'components/forms/application_original/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import Joi from 'joi';
import {Typography, Grid} from '@material-ui/core';
import FocusApplication from 'components/payment/FocusApplication';

const Endorsements = props => {
    const {initialValues} = bootstrapOldForm('Endorsements', fields);
    const pattern = '^\\d{3}-?\\d{2}-?\\d{4}$';

    const schema = {
        endorsement_text: Joi.string().required(),
        ssn: Joi.string()
            .regex(new RegExp(pattern))
            .required()
            .messages({'string.pattern.base': 'Must be formatted 000-00-0000'}),
        height_feet: Joi.number().integer().required(),
        height_inches: Joi.number().integer().required(),
        weight: Joi.number().integer().required(),
        sex: Joi.string().required(),
    };

    return (
        <Section {...props} {...{schema, initialValues}}>
            <FocusApplication applicationType='original' />
            <Typography>
                <strong>
                    Final Questions to make your application even faster at the NMC
                </strong>
            </Typography>
            <AutoField field={fields['endorsement_text']} name='endorsement_text' />
            <AutoField field={fields['ssn']} name='ssn' />
            <Typography>What is your height?</Typography>
            <Grid container>
                <AutoField field={fields['height_feet']} name='height_feet' />
                <Grid item style={{marginRight: '1em'}} />
                <AutoField field={fields['height_inches']} name='height_inches' />
            </Grid>
            <Typography>What is your weight?</Typography>
            <AutoField field={fields['weight']} name='weight' />
            <AutoField field={fields['sex']} name='sex' />
        </Section>
    );
};

export default Endorsements;
